import { faCheckCircle, faTimesCircle } from '@fortawesome/pro-solid-svg-icons';
import { FC } from 'react';
import { Tooltip } from 'src/components/overlay/tooltip';
import { LabelWithIcon } from 'src/pages/operators/assignments/overview/components/label-with-icon';
import { Colors } from 'src/styles';

export const MarketAreaCoordinatorMailedStatus: FC<{ isMailed: boolean }> = ({
  isMailed,
}) => (
  <Tooltip
    content={`Market Area Coordinator has${
      isMailed ? '' : ' NOT'
    } been notified about the assignment request via email.`}
  >
    {(targetProps) => (
      <LabelWithIcon
        {...targetProps}
        icon={isMailed ? faCheckCircle : faTimesCircle}
        color={isMailed ? Colors.success : Colors.error}
        label="MAC Notification"
      />
    )}
  </Tooltip>
);
